import { render, staticRenderFns } from "./SfIcon.vue?vue&type=template&id=69b491b7&"
import script from "./SfIcon.vue?vue&type=script&lang=js&"
export * from "./SfIcon.vue?vue&type=script&lang=js&"
import style0 from "./SfIcon.vue?vue&type=style&index=0&id=69b491b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports